module.exports = __webpack_public_path__ + "818180af8f05271b30ff2224ad261733.jpg";